<template lang="pug">
v-card(
  max-width="auto"
  class="mx-auto")

  v-app-bar(
    dark
    dense
    :color="sectionColor")

    v-btn(icon)
      v-icon {{ sectionIcon }}

    v-toolbar-title(class="text-body")
      | {{ sectionTitle }} ({{ fields.length }})

    v-spacer

    //- Seleccionar / deseleccionar todos
    v-checkbox(
      v-if="fields.length > 0"
      :input-value="allSelected"
      :indeterminate="someSelected"
      hide-details
      dense
      class="ma-0 pa-0"
      title="Seleccionar / deseleccionar todos"
      @change="toggleAll"
    )

  v-list(
    v-if="fields.length > 0"
    dense
    subheader)

    v-list-item-group
      v-list-item(
        :title="f.desc"
        class="py-0 my-0"
        v-for="f in fields"
        :key="f.name")

        v-list-item-action(class="py-0 my-0")
          v-checkbox(
            :input-value="f.checked"
            @click="updateVariable(f.key, 'checked', !f.checked)"
          )

        v-list-item-content(class="text-left py-0")
          v-list-item-title {{ f.name }}

        v-list-item-action(
          class="py-0 my-0"
          v-if="f.options"
        )
          v-menu(open-on-hover offset-y)
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                icon
                title="Ver Opciones"
                v-bind="attrs"
                v-on="on"
              )
                v-icon(
                  :color="`${f.selectedOption ? 'blue' : 'grey'} lighten-1`"
                ) mdi-cog

            v-list(dense v-model="f.selectedOption")
              v-list-item(
                v-for="option in f.options"
                @click="updateVariable(f.key, 'selectedOption', option)"
                :key="option"
              )
                v-list-item-title
                  | {{ option }} {{ f.selectedOption === option ? '(X)': '' }}

  span(
    class="text-h6 my-5 font-weight-light"
    v-else
  )
    | Aún no hay campos implementados para esta categoría
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: "ReportFolioSection",

  props: {
    sectionTitle: {
      type: String,
      required: true,
    },

    fields: {
      type: Array,
      required: true,
    },

    sectionColor: {
      type: String,
      required: false,
      default: 'pink'
    },

    sectionIcon: {
      type: String,
      required: false,
      default: 'mdi-list-status'
    }
  },

  computed: {
    // Todos están seleccionados
    allSelected() {
      return this.fields.length > 0 &&
        this.fields.every(field => field.checked);
    },

    // Algunos, pero no todos, están seleccionados
    someSelected() {
      const selected = this.fields.filter(field => field.checked).length;

      return selected > 0 && selected < this.fields.length;
    }
  },

  methods: {
    ...mapMutations('reports', ['UPDATE_MANAGER_VARIABLE']),

    updateVariable(variableKey, varAttr, varValue) {
      this.UPDATE_MANAGER_VARIABLE({
        variableKey,
        varAttr,
        varValue
      });
    },

    toggleAll(value) {
      this.fields.forEach(field => {
        this.updateVariable(
          field.key,
          'checked',
          value
        );
      });
    }
  }
}
</script>
